import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      content: {
        padding: theme.spacing(4, 2),
        paddingBottom: '0 !important',
      },
      text: {
        color: sicrediColor.secondarySicrediDarker,
        whiteSpace: 'pre-wrap',
      },
      footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingTop: 2,
        paddingBottom: 7,
        width: '100%',
        '& > button:not(:last-of-type)': {
          margin: theme.spacing(0, 2),
        },
      },
    }),
  { name: 'EcluirEventoModal' }
);
